module.exports = __webpack_public_path__ + "img/IMG_8157_L_Foamcore_MockedUp.6aeea900.jpg";